import { webKnots } from '../../../../common/back/lace/webKnots'
import { lacePartsOfWeb1, lacePartsOfWeb2, upLeftDownRight, upLeftDownRight2, upRightDownLeft, upRightDownLeft2 } from './parts/laceParts'
import { topSidePartOfWeb } from './parts/sideParts'
import { verticalPartOfVWeb3 } from './parts/verticalParts'

export const netVWeb = async (
  ctx: CanvasRenderingContext2D,
  laceColor: string,
  stitchColor: string,
  webColor: string,
  webColor2: string,
  printLeatherTypeValue?: string
): Promise<void> => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = webColor
  // 横上パーツ
  await topSidePartOfWeb(ctx, webColor, laceColor, stitchColor, printLeatherTypeValue)

  // 縦パーツ
  await verticalPartOfVWeb3(ctx, webColor2 || webColor, laceColor, stitchColor, printLeatherTypeValue)
  upLeftDownRight(ctx, laceColor, -3, -25)
  lacePartsOfWeb1(ctx, laceColor, -13, 2, 0, 1)
  lacePartsOfWeb1(ctx, laceColor, -30, 34, 0, 1)
  lacePartsOfWeb1(ctx, laceColor, -48, 64, 0, 1)
  lacePartsOfWeb1(ctx, laceColor, -33, 92, 1, 0.95)
  lacePartsOfWeb1(ctx, laceColor, -18, 132, 1, 0.9)
  upRightDownLeft(ctx, laceColor, 0, 0)
  upRightDownLeft2(ctx, laceColor, 29, -15)
  lacePartsOfWeb2(ctx, laceColor, -28, 0, -1, 1.05)
  lacePartsOfWeb2(ctx, laceColor, -13, 33, -1, 1)
  lacePartsOfWeb2(ctx, laceColor, -1, 68, -1, 0.95)
  lacePartsOfWeb2(ctx, laceColor, 8, 107, -1, 0.9)
  upLeftDownRight2(ctx, laceColor)

  // laceここから
  webKnots(ctx, laceColor, -90, 100) //
  webKnots(ctx, laceColor, -113, 125) // 捕球面折り返し上
  crossLace(ctx, laceColor, 75, -105)
  crossLace(ctx, laceColor, 40, -48)
  crossLace(ctx, laceColor, 0, 0)
  ctx.strokeStyle = '#282828'
}

const crossLace = (ctx: CanvasRenderingContext2D, laceColor: string, x: number, y: number): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = laceColor
  // 左下＿右上
  ctx.beginPath()
  ctx.moveTo(531 + x, 285 + y) // 左上
  ctx.quadraticCurveTo(526 + x, 287 + y, 526 + x, 295 + y) //左下
  ctx.quadraticCurveTo(551 + x, 287 + y, 570 + x, 286 + y) // 右上_下
  ctx.quadraticCurveTo(576 + x, 281 + y, 576 + x, 277 + y) // 右上_上
  ctx.quadraticCurveTo(550 + x, 276 + y, 531 + x, 285 + y) // 左上
  ctx.fill()
  ctx.moveTo(528 + x, 293 + y)
  ctx.quadraticCurveTo(548 + x, 283 + y, 572 + x, 284 + y)
  ctx.stroke()
  ctx.closePath()
  // 左上_右下
  ctx.beginPath()
  ctx.moveTo(545 + x, 263 + y) // 左上
  ctx.quadraticCurveTo(541 + x, 261 + y, 539 + x, 269 + y) //左下
  ctx.quadraticCurveTo(546 + x, 279 + y, 555 + x, 301 + y) // 右上_下
  ctx.quadraticCurveTo(560 + x, 303 + y, 561 + x, 296 + y) // 右上_上
  ctx.quadraticCurveTo(554 + x, 276 + y, 545 + x, 263 + y) // 左上
  ctx.fill()
  ctx.moveTo(540 + x, 266 + y)
  ctx.quadraticCurveTo(548 + x, 274 + y, 557 + x, 302 + y)
  ctx.stroke()
  ctx.closePath()
}
